export const SCHEDULED_ENTRY_TOOLTIP =
  'Not yet active. Excluded from current totals.'

type ScanUrlDict = {
  [key: string]: string
}

export const SCAN_URLS: ScanUrlDict = {
  ADA: 'https://explorer.cardano.org/en/address?address=',
  BCH: 'https://blockchair.com/bitcoin-cash/address/',
  BTC: 'https://www.blockchain.com/explorer/addresses/btc/',
  BTC_XPUB: 'https://www.blockonomics.co/#/search?q=',
  ETH: 'https://etherscan.io/address/',
  LTC: 'https://blockchair.com/litecoin/address/',
  SOL: 'https://solscan.io/account/',
  XRP: 'https://xrpscan.com/account/',
}

export const DEFAULT_CURRENCY_ICON_URL = `${
  import.meta.env.BASE_URL
}currencies/default-currency-icon.png`

export const TAGS_MAP_PARENT_KEY = '__parent__'
